<template>
  <div class="activity-login-popup">
    <img src="./images/logo.png" class="icon-logo" />
    <span class="text">{{ text }}</span>
    <span class="btn-login" @click="handleLogin">{{ btnText }}</span>
  </div>
</template>
<script>
export default {
  name: "ActivityLogin",
  props: {
    loginConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {
    text() {
      const { jumpText, loginText, loginGuide, jumpGuide } = this.loginConfig;
      if (loginGuide === 1 && jumpGuide === 1) {
        if (this.$store.getters.isLogin) {
          return jumpText;
        } else {
          return loginText;
        }
      }
      if (loginGuide === 1 && jumpGuide === 0) {
        return loginText;
      }
      if (loginGuide === 0 && jumpGuide === 1) {
        return jumpText;
      }
      return "";
    },
    btnText() {
      const { loginGuide, jumpGuide } = this.loginConfig;
      if (loginGuide === 1 && jumpGuide === 1) {
        if (this.$store.getters.isLogin) {
          return "去跳转";
        } else {
          return "去登录";
        }
      }
      if (loginGuide === 1 && jumpGuide === 0) {
        return "去登录";
      }
      if (loginGuide === 0 && jumpGuide === 1) {
        return "去跳转";
      }
      return "";
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
    platform() {
      return this.$store.state.commonStore.platform;
    },
  },
  mounted() {},
  methods: {
    generate6DigitUUID(num) {
      return Math.floor(100000 + Math.random() * (9 * 10 ** num)).toString();
    },
    handleLogin() {
      console.log(this.isLogin, this.loginConfig, "this.isLogin");
      // 已登录
      if (
        this.isLogin ||
        (!this.isLogin && this.loginConfig?.loginGuide !== 1)
      ) {
        console.log(this.loginConfig?.jumpPlatform,'jumpPlatform');
        if (this.loginConfig?.jumpGuide === 1) {
          let jumpUrl = this.loginConfig?.jumpLink;
          let deeplinkid =
            this.$route.query.deeplinkid || localStorage.getItem("deeplinkid");

          if (this.loginConfig?.jumpPlatform === 1) {
            // App端跳转
            let H5Url = this.replaceFirstParamWithDeepLinkId(
              jumpUrl,
              deeplinkid
            );
            let platform = this.platform;
            let platformPrefix = "qiancheng://home/show_webpage";
            if (platform == "yjsApp") {
              platformPrefix = "yingjiesheng://home/openWebPage";
            }
            if (!jumpUrl.startsWith("http")) {
              let params = this.getUrlParams(jumpUrl);
              H5Url = decodeURIComponent(params?.url);
              platformPrefix = this.getUrlBeforeQuestionMark(jumpUrl);
            }
            let _url = "";
            if (
              platformPrefix === "qiancheng://home/show_webpage" ||
              platformPrefix === "yingjiesheng://home/openWebPage"
            ) {
              _url = `${platformPrefix}${
                deeplinkid ? "?deeplinkid=" + deeplinkid + "&" : "?"
              }fullscreen=1&url=${encodeURIComponent(H5Url)}`;
            } else {
              _url = `${platformPrefix}${
                deeplinkid
                  ? "?deeplinkid=" +
                    deeplinkid +
                    (this.removeDeepLinkIdFromQueryString(jumpUrl) ? "&" : "")
                  : this.removeDeepLinkIdFromQueryString(jumpUrl)
                  ? "?"
                  : ""
              }${this.removeDeepLinkIdFromQueryString(jumpUrl)}`;
            }

            this.$sensors.track("$WebClick", {
              $element_id: "sensor_bcop_guide_click",
              contentType: "去app",
            });

            if (this.$store.getters.device == "harmonyApp") {
              window.harmony.jsAppBridgeOpenScheme(JSON.stringify({
                url: _url
              }));
            } else {
              window.location.href = _url;
            }
          } else if (this.loginConfig?.jumpPlatform === 2) {
            // 小程序端跳转
            let _jumpurl = this.getUrlBeforeQuestionMark(jumpUrl);
            let params = this.getUrlParams(jumpUrl);
            let query = "";
            if (_jumpurl == "pages/op/index") {
              query =
                `id=${params.id}` +
                (deeplinkid ? `&deeplinkid=${deeplinkid}` : "");
            } else {
              query = deeplinkid ? `&deeplinkid=${deeplinkid}` : "";
            }
            this.$sensors.track("$WebClick", {
              $element_id: "sensor_bcop_guide_click",
              contentType: "去小程序",
            });
            this.handleMiniLogin(_jumpurl, query);
          }
        }
      } else {
        // 未登录
        if (this.loginConfig?.loginGuide === 1 && !this.isLogin) {
          this.$sensors.track("$WebClick", {
            $element_id: "sensor_bcop_guide_click",
            contentType: "登录",
          });
          if (this.$store.getters.appType === "weixin") {
            const pageId = this.$route.params.pageId;
            let query = `id=${pageId}`;
            this.handleMiniLogin("pages/op/index", query);
          } else {
            this.$base.toLogin();
          }
        }
      }
    },
    // 获取url问号之后的部分
    removeDeepLinkIdFromQueryString(url) {
      var index = url.indexOf("?");
      if (index !== -1) {
        var queryParams = url.substring(index + 1);
        var newQueryParams = queryParams.replace(
          /(\w+)=(\w+)(?=&|$)/g,
          function (match, paramName) {
            if (paramName === "deeplinkid") {
              return "";
            }
            return match;
          }
        );
        return newQueryParams;
      } else {
        return "";
      }
    },

    // 获取url问号之前的部分
    getUrlBeforeQuestionMark(url) {
      var index = url.indexOf("?");
      if (index !== -1) {
        return url.substring(0, index);
      } else {
        return url;
      }
    },
    // 替换第一个参数
    replaceFirstParamWithDeepLinkId(url, deepLinkId) {
      var index = url.indexOf("?");
      if (index !== -1) {
        var baseUrl = url.substring(0, index);
        var queryParams = url.substring(index + 1);
        var newQueryParams = queryParams.replace(
          /^(\w+)=(\w+)(?=&|$)/,
          function (match, paramName) {
            if (paramName === "deeplinkid") {
              return paramName + "=" + deepLinkId;
            }
            return match;
          }
        );
        return baseUrl + "?" + newQueryParams;
      } else {
        return url + (deepLinkId ? "?deeplinkid=" + deepLinkId : "");
      }
    },
    // 小程序跳转
    handleMiniLogin(path, query) {
      const params = {
        from_domain: this.platform.includes("yjs")
          ? "yjs_wxapp"
          : "51job_weixin_wxapp",
        rand: this.generate6DigitUUID(9),
        guid: this.generate6DigitUUID(5),
        wx_biz: {
          path: path,
          query: query,
          expire_type: 1,
          expire_time: new Date().getTime() + 24 * 60 * 60 * 1000,
          expire_interval: 1,
          env_version:
            process.env.NODE_ENV === "production" ? "release" : "trial",
        },
      };
      console.log(
        this.platform,
        this.platform.includes("yjs"),
        params,
        "小程序跳转1--------------"
      );
      console.log(params,'params');
      this.$api.activity.getWxUrl(params).then((res) => {
        console.log(res);
        const { url_link = {} } = res.resultbody || {};
        if (url_link.errcode == "0") {
          const link = url_link.url_link;
          window.location.href = link;
        } else {
          this.$toast("获取微信短链失败");
        }
      });
    },
    getUrlParams(curl) {
      let url = curl;
      let params = {};
      let queryString = url.split("?")[1] || "";
      let keyValuePairs = queryString.split("&") || [];
      if (keyValuePairs.length > 0) {
        for (var i = 0; i < keyValuePairs.length; i++) {
          var keyValue = keyValuePairs[i].split("=");
          params[decodeURIComponent(keyValue[0])] = decodeURIComponent(
            keyValue[1]
          );
        }
      }
      return params;
    },
  },
};
</script>
<style scoped lang="less">
.activity-login-popup {
  position: fixed;
  left: 8px;
  right: 8px;
  bottom: 38px;
  height: 48px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 8px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 16px;
  z-index: 1;
  .pc & {
    width: 359px;
    left: 50%;
    transform: translateX(-50%);
  }
  .icon-logo {
    width: 28px;
    height: 28px;
    border-radius: 28px;
  }
  .text {
    padding-left: 8px;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .btn-login {
    display: inline-block;
    width: 64px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: linear-gradient(180deg, #ff7928 0%, #ff2946 100%);
    border-radius: 15px;
    font-size: 12px;
    color: #fff;
  }
}
</style>
